import { useEffect, useState } from 'react';
import { isMarketOpen } from '../Utils/marketHours';

// `isMarketOpen()` read during render only refreshes when something else makes the
// component re-render. That is fine for tiles driven by a data feed, but the
// Market Intelligence badge can sit for hours with no store change -- so a page
// left open across 16:00 kept claiming LIVE. This subscribes to the clock so the
// crossing itself is the trigger.
//
// Polls rather than scheduling a single timer at the close: a laptop that sleeps
// through 16:00 fires nothing on wake, and DST plus half days make the next
// boundary a moving target. A minute is well inside what a status badge needs.
const MARKET_CLOCK_POLL_MS = 60_000;

export function useMarketOpen(pollMs = MARKET_CLOCK_POLL_MS) {
  const [marketOpen, setMarketOpen] = useState(isMarketOpen);

  useEffect(() => {
    const sync = () => setMarketOpen((prev) => {
      const next = isMarketOpen();
      return next === prev ? prev : next;
    });

    sync(); // the clock may already have moved between mount and this effect
    const id = setInterval(sync, pollMs);
    return () => clearInterval(id);
  }, [pollMs]);

  return marketOpen;
}
